import Home from './Components/Home';
import Layout from './Components/Layout';
import About from './Components/About';
import Services from './Components/Services'
import Contact from './Components/Contact'
import './App.css';
import Navbar from './Components/Navbar';
import React from 'react';
import Amboseli from './Components/Amboseli';
import KenyaSafaris from './Components/KenyaSafaris';
import KilimanjaroSafari from './Components/KilimanjaroSafari';
import NairobiParkTrip from './Components/NairobiParkTrip';
import MasaiMaraSafari from './Components/MasaiMaraSafari';
import MalindiWatamuTour from './Components/MalindiWatamuTour';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Travelpackages from './Components/Travelpackages';
import BlogList from './Components/BlogList';
import BlogDetail from './Components/BlogDetail';
import LuxuriousLodges from './Components/LuxuriousLodges';
import UniqueExperiences from './Components/UniqueExperiences';
import Destinations from './Components/Destinations';
import HandpickedStays from './Components/HandpickedStays';
import Kenya from './Components/Kenya';
import Tanzania from './Components/Tanzania';
import SerengetiMigration from './Components/SerengetiMigration';
import KilimanjaroTsavo from './Components/KilimanjaroTsavo';
import KenyaHighlights from './Components/KenyaHighlights';
import NorthernTanzania from './Components/NorthernTanzania';
import BigFiveKenya from './Components/BigFiveKenya';
import LuxuryFlyingSafari from './Components/LuxuryFlyingSafari';
import WildHeartKenya from './Components/WildHeartKenya';
import KenyaTanzaniaHighlights from './Components/KenyaTanzaniaHighlights';
import TanzaniaZanzibar from './Components/TanzaniaZanzibar';
import AmboseliTsavoDiani from './Components/AmboseliTsavoDiani';
import EastAfricaGrand from './Components/EastAfricaGrand';
import UltimateLuxurySafari from './Components/UltimateLuxurySafari';
import ScrollToTop from './Components/ScrollToTop';
import Admin from './Components/Admin';
import WriteBlog from './Components/WriteBlog';



const App = () => {
  return (
    <BrowserRouter>
      
      <ScrollToTop />
      <Navbar />
      
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/tours" element={<Travelpackages />} />
          <Route path="/handpicked-stays" element={<HandpickedStays />} />
          <Route path="/amboseli" element={<Amboseli />} />
          <Route path="/safari-highlights" element={<KenyaSafaris />} />
          <Route path="/kilimanjaro" element={<KilimanjaroSafari />} />
          <Route path="/nairobi-park" element={<NairobiParkTrip />} />
          <Route path="/wildebeest-migration" element={<MasaiMaraSafari />} />
          <Route path="/malindi-watamu" element={<MalindiWatamuTour />} />
          <Route path="/kenya" element={<Kenya />} />
          <Route path="/tanzania" element={<Tanzania />} />
          <Route path="/serengeti-migration" element={<SerengetiMigration />} />
          <Route path="/kilimanjaro-tsavo" element={<KilimanjaroTsavo />} />
          <Route path="/kenya-highlights" element={<KenyaHighlights />} />
          <Route path="/northern-tanzania" element={<NorthernTanzania />} />
          <Route path="/big-five-kenya" element={<BigFiveKenya />} />
          <Route path="/luxury-flying-safari" element={<LuxuryFlyingSafari />} />
          <Route path="/wild-heart-kenya" element={<WildHeartKenya />} />
          <Route path="/kenya-tanzania-highlights" element={<KenyaTanzaniaHighlights />} />
          <Route path="/tanzania-zanzibar" element={<TanzaniaZanzibar />} />
          <Route path="/amboseli-tsavo-diani" element={<AmboseliTsavoDiani />} />
          <Route path="/east-africa-grand" element={<EastAfricaGrand />} />
          <Route path="/ultimate-luxury-safari" element={<UltimateLuxurySafari />} />
          <Route path="/blogs" element={<BlogList />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/blogs/luxury-lodges" element={<LuxuriousLodges />} />
          <Route path="/blogs/unique-experiences" element={<UniqueExperiences />} />
        <Route path="/contact" element={<Contact />} />
          <Route path="/design-your-trip" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/write" element={<WriteBlog />} />
        </Route>
      </Routes>
    
    
  {/* <App /> */}
</BrowserRouter>
    
  );
};

export default App;


// function App() {
//   return (
//     <div className="App">
//       <Navbar />
//       {/* <Home /> */}
//       {/* <About /> */}
//       {/* <Service /> */}
//       {/* <Contact /> */}

//     </div>
//   );
// }

// export default App;
